import { fetchTorneoEstado } from '../service/torneo';

export const loadTorneoEstado = () => async (dispatch) => {
  try {
    const res = await fetchTorneoEstado();
    dispatch({ type: 'TORNEO_ESTADO_SET', payload: res.data });
    return res.data;
  } catch (error) {
    console.error('Error al cargar estado del torneo:', error);
    return null;
  }
};
